
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Създаване на Организация</h5>
        <p class="text-center small">Моля, въведете основните данни на Организацията</p>
      </div>

      <form *ngIf="isLoaded" [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="title" class="form-label">Име</label>
          <input type="text" formControlName="title" class="form-control" id="title">
        </div>
        <div class="col-12">
          <label for="vat" class="form-label">ЕИК</label>
          <input type="text"
                 formControlName="vat"
                 class="form-control"
                 id="vat"
                 maxlength="9"
                 pattern="^[0-9]{9}$"
                 inputmode="numeric"
                 placeholder="Въведете 9-цифрен ЕИК">
        </div>
        <div class="col-12">
          <app-bank-selector (selectedAccount)="onBankAccountSelected($event)" />
        </div>
        <div class="col-12">
          <label for="description" class="form-label">Кратко Описание</label>
          <input type="text" formControlName="description" class="form-control" id="description">
        </div>
        <div class="form-group mt-4">
          <label for="responseType">Вид Обратна Връзка</label>
          <div class="payment-wrapper">
            <select class="form-control" id="responseType" formControlName="responseType">
              <option *ngFor="let method of responseTypes" [value]="method.value">
                {{GetCyrilicRequestType(method.value)}}
              </option>
            </select>
          </div>
        </div>
        <div class="col-12">
          <label for="orgType" class="form-label">Тип</label>
          <select formControlName="orgType" class="form-select">
            <option value="" disabled>Изберете Тип</option>
            <option *ngFor="let orgType of orgTypes" [value]="OrganizationalTypes[orgType]">{{ orgType.replace('_',' ') }}</option>
          </select>
        </div>
        <div class="col-12">
          <label class="form-label">Вид на Организацията</label>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="parentChildOrg" value="parent" id="parentRadio" (change)="onOrgTypeChange('parent')">
            <label class="form-check-label" for="parentRadio">Основна</label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" formControlName="parentChildOrg" value="child" id="childRadio" (change)="onOrgTypeChange('child')">
            <label class="form-check-label" for="childRadio">Дъщерна</label>
          </div>
        </div>

        <!-- Conditionally show this dropdown if "Child" is selected -->
        <div class="col-12" *ngIf="isChildSelected">
          <label for="parentOrg" class="form-label">Изберете Основна организация</label>
          <select formControlName="parentOrg" class="form-select" id="parentOrg">
            <option *ngFor="let org of organizations" [value]="org.id">{{ org.title }}</option>
          </select>
        </div>

        <!--- Module Uslugi -->
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="enableVik" [(ngModel)]="enableVik" (change)="onVikChange()">
            <label class="form-check-label" for="enableVik">Модул ВИК</label>
          </div>

          <div class="form-check">
            <input class="form-check-input" type="checkbox" id="enableServiceProvider" [(ngModel)]="isServiceProviderEnabled" (change)="onCheckboxChange()">
            <label class="form-check-label" for="enableServiceProvider">Модул Услуги</label>
          </div>
        </div>
        <div *ngIf="isServiceProviderEnabled" class="col-12">
          <label for="selectedAgent" class="form-label">Посредник</label>
          <select formControlName="selectedAgent" class="form-select">
            <option value="0" disabled>Не е избран Посредник</option>
            <option *ngFor="let agent of agents" [value]="agent.idAgent">{{ agent.agentName.replace('_',' ') }}</option>
          </select>
        </div>
        <div *ngIf="isServiceProviderEnabled" class="col-12">
          <label for="selectedProvider" class="form-label">Доставчик</label>
          <select formControlName="selectedProvider" class="form-select">
            <option value="0" disabled>Не е Избран Доставчик</option>
            <option *ngFor="let provider of providers" [value]="provider.idServiceProvider">{{ provider.serviceProviderName.replace('_',' ') }}</option>
          </select>
        </div>

        <!--- Module Uslugi -->

        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Създай</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
